import { isPortalBlackTailFillerAssetUrn } from '@lucimark/shared/helpers/portalBlackTailFillerAsset'

export { isPortalBlackTailFillerAssetUrn } from '@lucimark/shared/helpers/portalBlackTailFillerAsset'

export interface TPortalTailSandwichFrame {
  id?: string
  duration?: number
  playlistUrn?: string
  facets?: { main?: { asset?: string } }
}

function isPortalBlackTailFrame(row: TPortalTailSandwichFrame): boolean {
  return isPortalBlackTailFillerAssetUrn(row.facets?.main?.asset)
}

/**
 * Drop portal black tail filler rows sandwiched between two slot-sized frames on the same playlist.
 * Stale CPS builds inserted tails between house rotations; tails after a long booked creative must stay.
 */
function isPortalBookCpsFrameId(id: string | undefined): boolean {
  return typeof id === 'string' && id.startsWith('book-')
}

/** Drop black tail filler rows on portal Book materialized queues (stale CPS slack pads). */
export function stripPortalBookBlackTailFillerFrames<T extends TPortalTailSandwichFrame>(
  queue: T[]
): T[] {
  if (!queue.some(f => isPortalBookCpsFrameId(f.id))) {
    return queue
  }
  return queue.filter(f => !isPortalBlackTailFrame(f))
}

export function stripSandwichedPortalBlackTailFillerFrames<T extends TPortalTailSandwichFrame>(
  queue: T[]
): T[] {
  if (queue.length < 3) {
    return queue
  }
  const out: T[] = []
  for (let i = 0; i < queue.length; i++) {
    const cur = queue[i]!
    const prev = queue[i - 1]
    const next = queue[i + 1]
    if (
      prev != null
      && next != null
      && isPortalBlackTailFrame(cur)
      && !isPortalBlackTailFrame(prev)
      && !isPortalBlackTailFrame(next)
      && (prev.playlistUrn?.trim() ?? '') !== ''
      && prev.playlistUrn === next.playlistUrn
    ) {
      const curDur = cur.duration ?? 0
      const prevDur = prev.duration ?? 0
      const nextDur = next.duration ?? 0
      if (curDur > 0 && prevDur > 0 && nextDur > 0 && prevDur > curDur && prevDur > nextDur) {
        out.push(cur)
        continue
      }
      if (prevDur <= curDur + 1 && nextDur <= curDur + 1) {
        continue
      }
    }
    out.push(cur)
  }
  return out
}
